import { ASSESSMENT } from '../../Assessment/constants/api'

export const ASSESSMENT_AMENDMENT = `${ASSESSMENT}amendment/`
export const ASSESSMENT_AMENDMENT_ALL = `${ASSESSMENT_AMENDMENT}all`
export const ASSESSMENT_AMENDMENT_PUBLISH = `${ASSESSMENT_AMENDMENT}publish`
export const ASSESSMENT_MARK_CHANGE_STATUS = `${ASSESSMENT}change/status`
